import styled from "@emotion/styled";

export const PageContentWrapper = styled("div")`
    padding: 0 16px 110px;
`;
